import { featureCards } from '@/mocks/categories';

export default function FeatureSection() {
  return (
    <section id="guides" className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Why Choose Hipobuy Spreadsheet?
          </h2>
          <p className="text-foreground-600 font-body text-base">
            Everything you need to research smarter and shop with confidence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {featureCards.map((card) => (
            <div
              key={card.title}
              className="group relative rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer"
            >
              <img
                src={card.imageUrl}
                alt={card.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="text-background-50 font-heading text-lg md:text-xl font-semibold mb-2">
                  {card.title}
                </h3>
                <p className="text-background-200 text-sm font-body leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 line-clamp-3">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}